import { ActionType } from '../constants/trade.constant';

export interface Stock {
  id: string; // Unique identifier for the stock
  ticker: string; // Stock ticker symbol
  name: string; // Name of the company
  sector: string; // Sector the company belongs to
  industry: string; // Industry the company belongs to
  currentPrice: number; // Current price of the stock
  dailyHigh: number; // Daily high price
  dailyLow: number; // Daily low price
  volume: number; // Trading volume
  averageVolume: number; // Average Trading Volume
  marketCap: number;
  description: string;
  country: string;
}

export const STOCK_TABLE_HEADERS = {
  ticker: 'Ticker',
  name: 'Company',
  sector: 'Sector',
  industry: 'Industry',
  currentPrice: 'Price',
  dailyHigh: 'Daily high',
  dailyLow: 'Daily low',
  volume: 'Volume',
  averageVolume: 'Average volume',
  marketCap: 'Market cap',
  description: 'Description',
  country: 'Country',
};

export interface TOP_STOCK_DETAILS {
  company: string;
  revenue: number;
  noOfTrades: number;
  earningPercentage: number;
}

export interface StockOnHand {
  ticker: string;
  company: string;
  industry: string;
  quantity: number;
  averagePrice: number;
  action: ActionType;
}

export interface StockDropDownOption {
  ticker: string;
  company: string;
}
